module.exports = __webpack_public_path__ + "static/media/img-cash-info-mobile.5ba8ca53.png";